"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrinkingWaterSourcesFlags = void 0;
var enums_1 = require("../../enums");
var FlaggedEnum_1 = require("../FlaggedEnum");
exports.DrinkingWaterSourcesFlags = FlaggedEnum_1.FlaggedEnum.create(enums_1.DrinkingWaterSource, 1 << 9);
//# sourceMappingURL=DrinkingWaterSource.js.map